// Browsers word a failed dynamic import differently: Chrome and Edge,
// Firefox, and Safari respectively.
const CHUNK_LOAD_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

function isChunkLoadError(error: unknown): boolean {
  return error instanceof Error && CHUNK_LOAD_ERROR.test(error.message);
}

/** What the top-level error boundary shows in place of a crashed page. */
export function AppErrorFallback({ error }: { error: unknown }) {
  // Offline, a page whose code never loaded in this tab can't load now; that
  // isn't a bug, so say what's going on instead of "something went wrong".
  const pageUnavailableOffline = isChunkLoadError(error) && !navigator.onLine;

  return (
    <div className="card p-6 text-center max-w-md mx-auto mt-12">
      <p className="text-text-primary font-semibold">
        {pageUnavailableOffline ? "This page isn't available offline yet." : "Something went wrong."}
      </p>
      <p className="text-text-muted text-sm mt-1">
        {pageUnavailableOffline
          ? "Reconnect and try again. Anything you've logged is saved on this device."
          : "Try reloading the page. The error has been reported."}
      </p>
    </div>
  );
}
